/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { observer } from 'mobx-react';
import * as React from 'react';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { ICittaProductpdfSpecificationData } from './citta-productpdf-specification.data';
import { ICittaProductpdfSpecificationProps } from './citta-productpdf-specification.props.autogenerated';

export interface ICittaProductpdfSpecificationViewProps extends ICittaProductpdfSpecificationProps<ICittaProductpdfSpecificationData> {
    PdfSpecificationContainer: IModuleProps;
    PdfSpecificationContentContainer: INodeProps;
    PdfSpecificationContent: INodeProps;
    PdfSpecificationContentShow: boolean;
    ProductSku: string | undefined;
}

/**
 *
 * CittaProductpdfSpecification component
 * @extends {React.Component<ICittaProductpdfSpecificationProps<ICittaProductpdfSpecificationData>>}
 */

@observer
class CittaProductpdfSpecification extends React.Component<ICittaProductpdfSpecificationProps<ICittaProductpdfSpecificationData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const content: ICittaProductpdfSpecificationData = this.props.data;

        const pdfSpecificationContent = this._getProductSpecificationContent(content, config.pdfSpecificationTitle ? config.pdfSpecificationTitle : '');
        const productSku = content && content.product && content.product.result && content.product.result.ItemId;
        const CittaProductpdfSpecificationViewProps  = {
            ...this.props,
            PdfSpecificationContainer: {
                moduleProps: this.props,
                className: 'pdf-specification'
            },
            PdfSpecificationContentContainer: {
                className: 'pdf-specification-content',
                'aria-label': config.pdfSpecificationTitle
            },
            PdfSpecificationContent: {
                tag: 'a',
                href: pdfSpecificationContent,
                'aria-label': `Click here to read ${config.pdfSpecificationTitle}`,
                target: '_blank',
                rel: "noopener"
            },
            PdfSpecificationContentShow : pdfSpecificationContent ? true : false,
            ProductSku: productSku
        };

        return this.props.renderView(CittaProductpdfSpecificationViewProps) as React.ReactElement;
    }

    private _getProductSpecificationContent(content: ICittaProductpdfSpecificationData, specificationTitle: string): string {
        const productSpec = content.productSpecificationData.result;
        
        let contentText = '';
        if (productSpec) {
            productSpec.some(spec => {
                if (spec.TextValue && spec.Name === specificationTitle) {
                    if(specificationTitle === "Product Specifications PDF"){
                        if(productSpec.some(specAU => specAU.Name === "Product Specifications PDF AU" && specAU.TextValue)){
                            return false
                        }
                    }

                     if(specificationTitle === "Assembly Instructions PDF"){
                        if(productSpec.some(specAU => specAU.Name === "Assembly Instructions PDF AU" && specAU.TextValue)){
                            return false
                        }
                    }
                    contentText = spec.TextValue;
                    return true;
                }
                return false;
            });
        }
        return contentText;
    }
}

export default CittaProductpdfSpecification;
